import React, { Component } from "react";
import * as Constants from "../../../common/Global/constants";
import * as TemplateConstants from "../../../common/Global/templateConstants";
import { getLocalStorageVariables, isEmptyVariable, ifEmptyReturn, isEmptyArray, getOnlyFileNameFromPath, truncateString, isJsonString, handleTokenExpiry, getTrimmedText, removeHtmlTags, hasFeatureAccess } from "../../../common/Global/commonFunctions";
import { AddNewButtonLayout, TableIcon } from "../../../common/Global/globalStyles.style";
import AddNewResponseDialog from "./addNewResponseDialog";
import { Modal } from "react-bootstrap";
import AlertDialog from "../../../common/AlertDialog";
import AlertWithTextarea from "../../../common/AlertDialog/alertwithTextarea";
let userDetails = getLocalStorageVariables();

class ReviewHistoryDialog extends Component {
	constructor(props) {
		super(props);
		
		let isDraftObservation = false;
		if (this.props.location.pathname.includes(Constants.DRAFTOBSERVATIONS_PATH)) {
			isDraftObservation = true;
		}
		this.state = {
			componentDidMountFlag: false,
			showLoader: false,
			employeesList: [],
			showCreateDialog: false,
			showAddResponseConfirmDialog: false,
			target:[],
			isEdit:false,
			isDraftObservation:isDraftObservation,
			templateValues:[],
			responseTemplateFields:[],
			supportings:[],
			responseTemplateValues:[],
			observationResponses:[],
            alertDialogHeading: "",
            proceedBtnLabel: "",
			message:"",
            showBtnLoader: false,
			showAlertWithTextareaDialog:false,
			alertWithTextareaDialogMessage:"",
			responseFixedTemplateFields:{},
			disableResponseForReportResource:false,
			responseChanged:false,
			showAlertDialogInfo:false,
			alertDialogMessageInfo:"",
			accessAcceptedStatus:""
		};
		userDetails = getLocalStorageVariables();
	}

	componentDidMount() {}

	componentDidUpdate(prevProps) {
		if (JSON.stringify(prevProps) !== JSON.stringify(this.props) && this.props.showViewResponseDialog) {
			let isDraftObservation = false;
			if (this.props.location.pathname.includes(Constants.DRAFTOBSERVATIONS_PATH)) {
				isDraftObservation = true;
			}
			if(this.props.location.pathname.includes(Constants.FINALIZEDOBSERVATIONS_PATH) && 
				this.props.isClientResponseAfterCompletion){
				isDraftObservation = true;
			}
			this.setState({
				componentDidMountFlag: false,
				showLoader: false,
				employeesList: [],
				showCreateDialog: false,
				showAddResponseConfirmDialog: false,
				target:[],
				isEdit:false,
				responseTemplateValues:[],
				isDraftObservation:isDraftObservation,
				disableResponseForReportResource:false,
				responseChanged:false,
				accessAcceptedStatus:""
			},() => {
				this.getInitData();
			});
		}
	}
	handleReopenDialogShow = () => {
		this.setState({
			operationType: "Reopen",
			alertDialogHeading: "Reopen Task",
			proceedBtnLabel: "Okay",
			deleteReactivateId: this.props.assignmentTaskId,
			showAlertWithTextareaDialog: true,
			alertWithTextareaDialogMessage:
				"Are you sure you want to reopen " +
				getTrimmedText(removeHtmlTags(this.props.selectedObservationHeading)) +
				" ?",
		});
	}

	handleAlertDialogClose = () => {
        this.setState({
            showAlertDialog: false,
            alertDialogMessage: "",
            operationType:"",
            deleteReactivateId:"",
        });
    };

	handleAlertDialogCloseInfo = () => {
        this.setState({
            showAlertDialogInfo: false,
            alertDialogMessageInfo: "",
        });
    };

	handleUnassignDialogShow = () => {
		let entityLabel = !isEmptyVariable(this.props.observationId) ? "observation" : "task";
		let alertDialogMessage = "Are you sure you want to unassign this "+entityLabel+"?";
		let hasActualResponse = Object.values(this.state.responseTemplateValues || {}).some(value => !isEmptyVariable(value));
		if(hasActualResponse){
			alertDialogMessage = "A response has already been submitted for this assignment. Unassigning will permanently delete it. Are you sure you want to continue?";
		}
		this.setState({
			operationType: "Unassign",
			alertDialogHeading: "Unassign",
			proceedBtnLabel: "Yes",
			showAlertDialog: true,
			alertDialogMessage: alertDialogMessage,
		});
	}

	handleAddNewClick = () => {
		if(hasFeatureAccess(Constants.FEATURE_CLIENT_LOGIN) && this.props.isAllowClientToRespond){
			this.setState({ showAddResponseConfirmDialog: true });
		}else{
			this.handleCreateDialogShow();
		}
	};

	handleAddResponseConfirmDialogClose = () => {
		this.setState({ showAddResponseConfirmDialog: false });
	};

	handleAddResponseConfirmProceed = () => {
		this.setState({ showAddResponseConfirmDialog: false }, () => {
			this.handleCreateDialogShow();
		});
	};

	handleCreateDialogShow = () => {
		this.setState({
			showCreateDialog: true,
			selectedId: "",
			isEdit: false,
		});
	};
	handleEditDialogShow = () => {
		this.setState({
			showCreateDialog: true,
			selectedId: "",
			isEdit: true,
		});
	};

	handleAddDialogClose = (reloadFlag) => {
		this.setState({
			showCreateDialog: false,
			responseChanged: reloadFlag == true ? true : this.state.responseChanged,
		},() => {
			if (reloadFlag == true) this.getInitData();
		}
		);
	};

	handleDialogClose = () => {
		this.props.handleViewResponseDialogClose(this.state.responseChanged);
	};

	downloadAttachment = (documentPath,e) => {
        e.stopPropagation();
        fetch(Constants.API_SERVER_PATH+documentPath)
        .then(response => { return response.blob(); } )
        .then(blob => {
            let fileName = getOnlyFileNameFromPath(documentPath);
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        });
    }

	getInitData = () => {
		this.setState({
			showLoader: true,
		});

		let url = "";
		if(this.props.isDraftOnward === true){
			url = Constants.GetDraftObservationResponse;
		}else{
			url = Constants.GetObservationResponses;
		}

		let params = {
			email: userDetails.email,
			accessToken: userDetails.accessToken,
            assignmentId: this.props.assignmentId,
		}

		if(this.props.isDraftOnward === true && this.props?.isCompletedAuditee !== true){
			params.forDraft = true;
		}

		if(!isEmptyVariable(this.props.observationId)){
			params.observationId = this.props.observationId
		}else if(!isEmptyVariable(this.props.assignmentTaskId)){
			params.assignmentTaskId = this.props.assignmentTaskId
		}
		if(this.props?.isCompletedAuditee === true){
			params.forCompleted = true;
		}

		fetch(url, {
			method: "POST",
			mode: "cors",
			body: new URLSearchParams(params),
		})
		.then((response) => {
			return response.json();
		})
		.then((data) => {
			if(handleTokenExpiry(data.responseCode)) return;
			else if (data.responseCode === Constants.CODE_SUCCESS) {
				let targetArr = [];
				let target = "";
				let responseTemplateFields = [];
				let supportings = [];
				let employees = data.data.employees;
				let observationResponse = data.data.observationResponses;
				let message = data.data.message;
				let disableResponseForReportResource = data.data.disableResponseForReportResource === true;
				let accessAcceptedStatus = data.data.accessAcceptedStatus;
				supportings = data.data.supportings;
				let responseFixedTemplateFields = {};
				if(!isEmptyVariable(data.data.responseTemplateFields)){
					try{
						responseTemplateFields = JSON.parse(data.data.responseTemplateFields)
					}catch(e){}
				}
				if(!isEmptyVariable(data.data.responseFixedTemplateFields)){
					try{
						responseFixedTemplateFields = JSON.parse(data.data.responseFixedTemplateFields);
					}catch(e){}
				}
				if(!isEmptyArray(observationResponse)){
					if(!isEmptyVariable(observationResponse[0].immediate) && observationResponse[0].immediate === "Y" ){
						targetArr.push("Immediate");
					}
					if(!isEmptyVariable(observationResponse[0].continuous) && observationResponse[0].continuous === "Y" ){
						targetArr.push("Continuous");
					}
					if(!isEmptyVariable(observationResponse[0].customTarget)){
						targetArr.push(observationResponse[0].customTarget);
					}
					target = targetArr.join(", ")
				}
				let tmpTemplaveValues = {};
				if(!isEmptyArray(observationResponse)){
					try{
						let tmpValues = observationResponse;
						tmpValues.map(e=>{
							const key = e["fieldId"]
							tmpTemplaveValues[key] = e["value"]
						})
					}catch(e){}
				}
				this.setState({
					employeesList: employees,
					observationResponses:observationResponse,
					message:message,
					showLoader: false,
					supportings:supportings,
					responseTemplateFields:responseTemplateFields,
                    responseTemplateValues:tmpTemplaveValues,
					componentDidMountFlag: true,
					target:target,
					responseFixedTemplateFields:responseFixedTemplateFields,
					disableResponseForReportResource:disableResponseForReportResource,
					accessAcceptedStatus:accessAcceptedStatus
				});
			} else {
				this.setState({
					employeesList: [],
					showLoader: false,
					componentDidMountFlag: true,
				});
			}
		});
	};

	handleAlertWithTextareaDialogClose = (remarks, reloadFlag) => {
        if(reloadFlag !== true){
            this.setState({
                operationType:"",
                alertDialogHeading:"",
                proceedBtnLabel:"",
                deleteReactivateId:""
            })
        }
        this.setState({
            showAlertWithTextareaDialog: false,
            alertWithTextareaDialogMessage: "",
            remarks: remarks,
        },() => {
            if(reloadFlag === true){
                this.handleRecordOperation();
            }
        });
    };

	handleRecordOperation = () => {
		let url = "";
		let postParam = {
			email: userDetails.email,
			accessToken: userDetails.accessToken,
		};
		if(this.state.operationType === "Unassign"){
			url = Constants.UnassignEmployeeOrAuditee;

			if(!isEmptyVariable(this.props.assignmentId)){
				postParam.assignmentId = this.props.assignmentId;
			}
			if(!isEmptyVariable(this.props.assignmentTaskId)){
				postParam.assignmentTaskId = this.props.assignmentTaskId;
			}
			if(!isEmptyVariable(this.props.observationId)){
				postParam.observationId = this.props.observationId;
			}
		}else if(this.state.operationType === "Reopen"){
			url = Constants.GetAuditeeEmployeeDraftReports+"/"+this.props.assignmentId+"/observations/responses/reopen";

			if(!isEmptyVariable(this.props.observationId)){
				postParam.observationId = this.props.observationId;
			}else if(!isEmptyVariable(this.props.assignmentTaskId)){
				postParam.assignmentTaskId = this.props.assignmentTaskId;
			}
			// add remarks
			if(!isEmptyVariable(this.state.remarks)){
				postParam.remark = this.state.remarks;
			}else{
				postParam.remark = "";
			}
		}
		this.setState({
			showBtnLoader: true,
		});
		fetch(url, {
			method: "POST",
			mode: "cors",
			body: new URLSearchParams(postParam),
		})
		.then((response) => {
			return response.json();
		})
		.then((data) => {
			if(handleTokenExpiry(data.responseCode)) return;
			else if (data.responseCode === Constants.CODE_SUCCESS) {
				let operationType = this.state.operationType;
				this.setState({
					deleteReactivateId: "",
					operationType: "",
					alertDialogHeading: "",
					proceedBtnLabel: "",
					alertDialogMessage: "",
					showAlertDialog: false,
					showBtnLoader:false,
					remarks:"",
				},() => {
					if(operationType === "Unassign"){
						this.props.handleViewResponseDialogClose(true);
					}else{
						this.setState({ responseChanged: true },() => {
							this.getInitData();
						});
					}
				});
			} else {
				this.setState({
					showBtnLoader: false,
					deleteReactivateId: "",
					operationType: "",
					alertDialogHeading: "",
					proceedBtnLabel: "",
					alertDialogMessage: "",
					showAlertDialog: false,
					showAlertDialogInfo: true,
					alertDialogMessageInfo: data.responseMessage,
					remarks:"",
				});
			}
		});
	}

	render() {
		const isAssignForResponseActive = hasFeatureAccess(Constants.FEATURE_CLIENT_LOGIN) && this.props.isAllowClientToRespond;
		const canReopen = this.props.allowEdit === "Y" &&
			this.props.isCurrentUserReportResource &&
			hasFeatureAccess(Constants.FEATURE_EDIT_CLIENT_COMMENT) &&
			this.props?.isAllowEditClientComment &&
			!isEmptyArray(this.state.observationResponses) &&
			this.state.observationResponses[0].isFrozenForClient === "Y";
		return (
			<Modal className="review-history-dialog custom-dialog" show={this.props.showViewResponseDialog} onHide={this.handleDialogClose}>
				<Modal.Header>
					<h5>Response</h5>
					<button onClick={this.handleDialogClose} type="button" data-dismiss="modal">
						<span class="material-icons">close</span>
					</button>
				</Modal.Header>
				<hr />
				<div className="modal-body">
					{this.state.showLoader && (
						<div class="loader"></div>
					)}
					<div className="review-history-wrapper">
						{
							this.state.componentDidMountFlag &&
							this.state.isDraftObservation &&
							!this.props.isReportCompleted &&
							<div className="search-addnew-bg">
								<div className="search-addnew" style={{justifyContent:'flex-end'}}>
									<div></div>
									{(this.state.accessAcceptedStatus === "accepted" || !isEmptyVariable(this.state.message)) && !canReopen &&
										<AddNewButtonLayout themeSettings={this.props.themeSettings} style={{marginRight:10}}>
											<a onClick={this.handleUnassignDialogShow} href="javascript:void(0);">
												<span className="material-icons">person</span>
												<p>Unassign</p>
											</a>
										</AddNewButtonLayout>
									}
									{isEmptyVariable(this.state.message) &&
										<>
											{canReopen &&
												<AddNewButtonLayout themeSettings={this.props.themeSettings} style={{marginRight:10}}>
													<a onClick={this.handleReopenDialogShow} href="javascript:void(0);">
														<span className="material-icons">replay</span>
														<p>Reopen</p>
													</a>
												</AddNewButtonLayout>
											}
											{/* {isEmptyArray(this.state.observationResponses) && this.state.isDraftObservation &&
											<AddNewButtonLayout themeSettings={this.props.themeSettings}>
												<a onClick={this.handleAddNewClick} href="javascript:void(0);">
													<span className="material-icons">add_circle</span>
													<p>Add New</p>
												</a>
											</AddNewButtonLayout>
											} */}
											{this.props.allowEdit === "Y" &&
											this.props.isCurrentUserReportResource &&
											!this.state.disableResponseForReportResource &&
											isAssignForResponseActive &&
											isEmptyArray(this.state.observationResponses) &&
											// this.state.observationResponses[0].isFrozenForClient === "N" &&
											this.state.isDraftObservation &&
											<AddNewButtonLayout themeSettings={this.props.themeSettings}>
												<a onClick={this.handleAddNewClick} href="javascript:void(0);">
													<span className="material-icons">add_circle</span>
													<p>Add Response</p>
												</a>
											</AddNewButtonLayout>
											}

											{this.props.allowEdit === "Y" &&
											this.props.isCurrentUserReportResource &&
											!this.state.disableResponseForReportResource &&
											hasFeatureAccess(Constants.FEATURE_EDIT_CLIENT_COMMENT) &&
											!isEmptyArray(this.state.observationResponses) &&
											this.props?.isAllowEditClientComment &&
											(isAssignForResponseActive || this.state.observationResponses[0]?.isFrozenForClient !== "N") &&
												<AddNewButtonLayout themeSettings={this.props.themeSettings}>
													<a onClick={this.handleEditDialogShow} href="javascript:void(0);">
														<span className="material-icons">edit</span>
														<p>Edit Response</p>
													</a>
												</AddNewButtonLayout>
											}
										</>
									}
								</div>
							</div>
						}
						
						{this.state.componentDidMountFlag &&
						!isEmptyVariable(this.state.message) &&
							<div className="dialog-no-records">
								<p>{this.state.message}</p>
							</div>
						}

						{this.state.componentDidMountFlag &&
						isEmptyVariable(this.state.message) &&
						(!isEmptyArray(this.state.observationResponses) ||
						this.state.observationResponses[0]?.isFrozenForClient !== "N") && (
							<div className="review-history-list">
								<div className="history-item-layout">
								{this.state.responseTemplateFields.map((item,index)=>{
									let isFieldIdCheck = isEmptyVariable(this.state.responseTemplateValues[item.fieldId]);
									let fieldIdValue = this.state.responseTemplateValues[item.fieldId];
									let employeeName = [];
									if(item.fieldType === TemplateConstants.FIELD_TYPE_DROPDOWN_MULTI &&
										item.isResponsibilityField == "Y" && item?.isResponsibilityFieldEnabled === "Y"){
										this.state.employeesList.map(e => {
											!isFieldIdCheck && JSON.parse(fieldIdValue).map(id => {
												if(id == e.employeeId){
													employeeName.push(e)
												}
											})
										})
									}
									return (
										<>
											{/* {
												index == 1 && !isEmptyVariable(this.state.target) &&
												<span>Target : {" "+this.state.target}</span>
											} */}
											{(item.fieldType === TemplateConstants.FIELD_TYPE_TEXT ||
												item.fieldType === TemplateConstants.FIELD_TYPE_DATE ||
												item.fieldType === TemplateConstants.FIELD_TYPE_DROPDOWN ||
												item.fieldType === TemplateConstants.FIELD_TYPE_OPEN_CLOSED) &&
												!isFieldIdCheck && <span>{item.fieldName} : {" "}{fieldIdValue}</span>
											}
											{
												item.fieldType === TemplateConstants.FIELD_TYPE_DROPDOWN_MULTI &&
												item.isResponsibilityField == "Y" && item?.isResponsibilityFieldEnabled === "Y" && !isFieldIdCheck && 
												<span>{item.fieldName} : {" "}
												{employeeName.map((item, index) => {
													return <>{(index ? ", " : "") + ifEmptyReturn(item.salutation) + " " + item.firstName + " " + ifEmptyReturn(item.middleName) + " " + item.lastName}</>
												})}</span>
											}
											{
												item.fieldType === TemplateConstants.FIELD_TYPE_DROPDOWN_MULTI &&
												isEmptyVariable(item.isResponsibilityField) && !isFieldIdCheck && 
												<span>{item.fieldName} : {" "}
													{isJsonString(fieldIdValue) ? JSON.parse(fieldIdValue).join(", ") : fieldIdValue}
												</span>
											}
											{
												item.fieldType === TemplateConstants.FIELD_TYPE_TABLE && !isFieldIdCheck && 
												<>
													{(item.fieldName + " : ")}
													<table class="table instances-table custom-table">
														{
															!isFieldIdCheck && JSON.parse(fieldIdValue).map((rowItem, rowIndex) =>  {
																if(rowIndex === 0){
																	return <thead className="instances-thead display-table">
																		<tr>
																		{
																			rowItem.map((colItem, colIndex) => {
																				return <th width={colItem === "Action"?"5%":""} className= {colItem === "Action"?"text-center":""}>
																					<div className="instances-table-header">
																						<p>
																							{colItem === "Action" ? "" : colItem}
																						</p>
																					</div>
																				</th>
																			})
																		}
																		</tr>
																	</thead>
																}else{
																	return <tbody className="instances-thead display-table">
																		<tr>
																		{
																			rowItem.map((colItem, colIndex) => {
																				return <td
																					className={colItem === "Action" ? "text-center" : ""}
																				>
																					{colItem === "Action" ? "" : colItem}
																				</td>
																			})
																		}
																		</tr>
																	</tbody>
																}
															})
														}
													</table>
												</>
											}
										</>
									)
								})}
								</div>
								{this.state.responseFixedTemplateFields?.backups === "Y" &&
								!isEmptyArray(this.state.supportings) &&
									<div className="common-tab-bg">
										<div className="common-table" style={{width:"100%"}}>
											<table className="table">
												<thead>
													<tr>
														<th className="text-center" width={"5%"}>No.</th>
														<th width={"5%"}>File Name</th>
														<th width={"5%"}>Remarks</th>
														<th className="text-center" width={"5%"}>Download</th>
													</tr>
												</thead>
												<tbody>
													{this.state.supportings.map((item,index) => {
														return(
															<tr>
																<td className="text-center">{(index+1)}</td>
																<td>{getOnlyFileNameFromPath(item.filePath)}</td>
																<td>{truncateString(item.remarks,Constants.STRING_LENGTH)}</td>
																<TableIcon themeSettings={this.props.themeSettings} className="text-center">
																	<span class="material-icons" onClick={this.downloadAttachment.bind(this, item.filePath)}>get_app</span>
																</TableIcon>
															</tr>
														)
													})}
												</tbody>
											</table>
										</div>
									</div>
								}
							</div>
						)}
						{this.state.componentDidMountFlag && isEmptyArray(this.state.observationResponses) && 
						isEmptyArray(this.state.supportings) && (
							<div className="dialog-no-records">
								<p>{Constants.NO_RECORDS_WARNING}</p>
							</div>
						)}
					</div>
				</div>

				<AddNewResponseDialog
					showAddResponseDialog={this.state.showCreateDialog}
					handleAddResponseDialogClose={this.handleAddDialogClose}
					observationId= {this.props.observationId}
					themeSettings={this.props.themeSettings}
                    assignmentId = {this.props.assignmentId}
					assignmentTaskId={this.props.assignmentTaskId}
					isEdit={this.state.isEdit}
					responseObj={this.state.observationResponses}
					supportings={this.state.supportings}
					isDraftOnward = {this.props.isDraftOnward}
					isOngoingOnward = {this.props.isOngoingOnward}
					responseTemplateFields={this.state.responseTemplateFields}
					employees={this.state.employeesList}
					responseFixedTemplateFields={this.state.responseFixedTemplateFields}
					isAllowClientToRespond={this.props.isAllowClientToRespond}
				/>
				<AlertDialog
					showAlertDialog={this.state.showAddResponseConfirmDialog}
					handleAlertDialogClose={this.handleAddResponseConfirmDialogClose}
					type={Constants.ALERT_TYPE_WARNING}
					alertDialogHeading={"Add Response"}
					alertDialogMessage={"Are you sure you don't want to send observation for the response from client?"}
					proceedBtnClick={this.handleAddResponseConfirmProceed}
					proceedBtnLabel={"Yes"}
					themeSettings={this.props.themeSettings}
				/>
				<AlertDialog
					showAlertDialog={this.state.showAlertDialog}
					handleAlertDialogClose={this.handleAlertDialogClose}
					type={Constants.ALERT_TYPE_INFO}
					alertDialogHeading={this.state.alertDialogHeading}
					alertDialogMessage={this.state.alertDialogMessage}
					proceedBtnClick={this.handleRecordOperation}
					proceedBtnLabel={this.state.proceedBtnLabel}
					showLoader={this.state.showBtnLoader}
					themeSettings={this.props.themeSettings}
				/>

				<AlertWithTextarea
					showAlertDialog={this.state.showAlertWithTextareaDialog}
					handleAlertDialogClose={this.handleAlertWithTextareaDialogClose}
					alertDialogHeading={this.state.alertDialogHeading}
					alertDialogMessage={this.state.alertWithTextareaDialogMessage}
					proceedBtnClick={this.handleAlertWithTextareaDialogClose}
					proceedBtnLabel={this.state.proceedBtnLabel}
					showLoader={this.state.showBtnLoader}
					themeSettings={this.props.themeSettings}
				/>
				<AlertDialog
					showAlertDialog={this.state.showAlertDialogInfo}
					handleAlertDialogClose={this.handleAlertDialogCloseInfo}
					type={Constants.ALERT_TYPE_ALERT}
					alertDialogMessage={this.state.alertDialogMessageInfo}
					proceedBtnClick={this.handleAlertDialogCloseInfo}
					proceedBtnLabel={Constants.ALERT_TYPE_OKAY_LABEL}
					themeSettings={this.props.themeSettings}
				/>

			</Modal>
		);
	}
}

export default ReviewHistoryDialog;
